import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import StatusDot, { StatusStyle } from '../../components/Status/StatusDot';
import React from 'react';
import { Column } from '../../hooks/useTablePages';

const columns: Column[] = [
  {
    id: 'status',
    header: 'Status',
    accessor: (vendor: any) => {
      let style: StatusStyle = 'default';
      switch (vendor.status) {
        case 'ACTIVE':
          style = 'success';
          break;
        case 'INACTIVE':
          style = 'error';
          break;
      }
      return <StatusDot status={style} mr="1" />;
    },
    stringAccessor: (vendor: any): string => {
      return constantToLabel(vendor.status);
    },
    width: 80,
  },
  {
    header: 'Name',
    accessor: 'profile.name',
    width: 300,
  },
  {
    header: 'Account',
    accessor: 'accountNumber',
    width: 150,
  },
  {
    id: 'profile.phones.value',
    header: 'Phone',
    accessor: (row: any) => row.profile.phones[0]?.value,
    width: 140,
    sortable: false,
  },
  {
    id: 'profile.emails.value',
    header: 'Email',
    accessor: (row: any) => row.profile.emails[0]?.value,
    width: 300,
    sortable: false,
  },
];

export default columns;
